<template>
    <button class="button button--primary button--compact" @click="login">
        Log In
    </button>
</template>

<script setup lang="ts">
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { Auth0 } from '@/Services/Auth0/auth0-interface'

    const auth0: Auth0 | null = useAuth0();

    const login = () => {
        if (!auth0) {
            console.log('Hit !auth0 on Login Button');
            return;
        }
        console.log('Hitting auth0.login');
        auth0.login()

    };


</script>
